/**
 * History plugin extensions
 * @module
 */

export * from './keyboard'
